import {createSlice} from '@reduxjs/toolkit';

const initialState = {
   mensajeIntro: 'Investigación e Innovación a tu servicio.',
   website: 'https://www.dscont.pe/',
   razonSocial: 'DataService Capacitación SRL.',
   esProduccion: !process.env.NODE_ENV !== 'production' && process.env.REACT_APP_DS_ENV === 'PROD',
};

const appGen = createSlice({
   name: 'appGen',
   initialState: initialState,
   reducers: {}
});

const appGenReducer = appGen.reducer;
export default appGenReducer;
